import React from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { FaFacebookF, FaInstagramSquare, FaRegHeart } from 'react-icons/fa'
import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { AiOutlineShopping } from 'react-icons/ai'

const Footer = () => {
  const navigate = useNavigate()
  const { t, i18n } = useTranslation()

  const currentLanguage = i18n.language
  const isRTL = currentLanguage === 'ar' || currentLanguage === 'kr'

  const { userInfo } = useSelector((state) => state.auth)
  const { buy_product_item, wishlist_count } = useSelector(
    (state) => state.card,
  )
  const footerLogo = '../../../images/wlogo.png'
  return (
    <footer className="bg-[#222529] mt-0">
      <div className="w-[70%] flex flex-wrap mx-auto border-b py-16 md-lg:pb-10 sm:pb-6">
        <div className="w-3/12 lg:w-4/12 sm:w-full">
          <div className="flex flex-col justify-start gap-3">
            <Link to="/">
              <img className="w-[100px]  " src={footerLogo} alt="" />
            </Link>
            <ul className="flex flex-col gap-2 text-white">
              <li>
                Snus pouches — a discreet and smoke-free way to enjoy nicotine,
                anytime, anywhere.
              </li>
              {/* <li>Phone : 4343434344</li>
                            <li>Email : support@easylearingbd.com</li> */}
            </ul>
          </div>
        </div>

        <div className="w-5/12 lg:w-8/12 sm:w-full">
          <div className="flex justify-center sm:justify-start sm:mt-6 w-full">
            <div>
              <h2 className="font-bold text-md text-tinyGold mb-2">
                {t('home.usefull_links')}{' '}
              </h2>
              <div className="flex justify-between gap-[80px] lg:gap-[40px]">
                <ul className="flex flex-col gap-2 text-white text-sm font-normal">
                  <li>
                    <Link to="/categories"> {t('home.categoreis')} </Link>
                  </li>
                  {/* <li>
                    <Link>Products </Link>
                  </li> */}
                  <li>
                    <Link to="/about_us"> {t('home.about_us')}</Link>
                  </li>
                  <li>
                    <Link to="/contact">{t('home.contact_us')} </Link>
                  </li>
                  {/* <li>
                            <Link>Blogs  </Link>
                        </li> */}
                </ul>

                {/* <ul className='flex flex-col gap-2 text-slate-600 text-sm font-semibold'>
                        <li>
                            <Link>Our Service </Link>
                        </li>
                        <li>
                            <Link>Company Profile</Link>
                        </li>
                        <li>
                            <Link>Delivery Information </Link>
                        </li>
                        <li>
                            <Link>Privacy Policy </Link>
                        </li>
                        <li>
                            <Link>Blogs  </Link>
                        </li>
                    </ul> */}
              </div>
            </div>
          </div>
        </div>

        <div className="w-4/12 lg:w-full lg:mt-6">
          <div className="w-full flex flex-col justify-start gap-5">
            <h2 className="font-bold text-tinyGold text-mg mb-2">
              {t('home.join_us')}
            </h2>
            {/* <span>Get Email updates about tour latest and shop specials offers</span>
                    <div className='h-[50px] w-full bg-white border relative'>
                        <input className='h-full bg-transparent w-full px-3 outline-0' type="text" placeholder='Enter Your Email' />
                        <button className='h-full absolute right-0 bg-[#059473] text-white uppercase px-4 font-bold text-sm'>Subscribe</button>  
                     </div>  */}
            <ul className="flex justify-start items-center gap-3">
              <li>
                <a
                  className="w-[38px] h-[38px] hover:bg-[#1877F2] hover:text-white flex justify-center items-center bg-white rounded-full"
                  href="#"
                  target="_blank"
                  rel="noreferrer"
                >
                  <FaFacebookF size={22} />{' '}
                </a>
              </li>

              <li>
                <a
                  className="w-[38px] h-[38px] hover:bg-[#E1306C] hover:text-white flex justify-center items-center bg-white rounded-full"
                  href="https://www.instagram.com/snusco.iq?igsh=d3R4cGozMzM5Z2w2"
                  target="_blank"
                  rel="noreferrer"
                >
                  <FaInstagramSquare size={22} />{' '}
                </a>
              </li>
              {/* <li>
                <a
                  className="w-[38px] h-[38px] hover:bg-[#059473] hover:text-white flex justify-center items-center bg-white rounded-full"
                  href="#"
                >
                  <FaLinkedin />{' '}
                </a>
              </li>
              <li>
                <a
                  className="w-[38px] h-[38px] hover:bg-[#059473] hover:text-white flex justify-center items-center bg-white rounded-full"
                  href="#"
                >
                  <FaGithub />{' '}
                </a>
              </li> */}
            </ul>
          </div>
        </div>
      </div>

      <div className="w-[90%] flex flex-wrap justify-center items-center text-tinyGold mx-auto py-5 text-center">
        <span>Copiright @ 2025 All Rights Reserved </span>
      </div>

      <div className="hidden fixed md-lg:block w-[50px] h-[110px] bottom-3 right-2 z-[9999] bg-darkRed rounded-full p-2">
        <div className="w-full h-full flex gap-3 flex-col justify-center items-center">
          <div
            onClick={() => navigate(userInfo ? '/card' : '/login')}
            className="relative flex justify-center items-center cursor-pointer w-[35px] h-[35px] rounded-full bg-white"
          >
            <span className="text-xl text-primary">
              <AiOutlineShopping className=" w-6 h-6" />
            </span>
            {buy_product_item !== 0 && (
              <div className="w-[20px] h-[20px] absolute bg-red-500 rounded-full text-white flex justify-center items-center -top-[3px] -right-[5px]">
                {buy_product_item}
              </div>
            )}
          </div>

          <div
            onClick={() =>
              navigate(userInfo ? '/dashboard/my-wishlist' : '/login')
            }
            className="relative flex justify-center items-center cursor-pointer w-[35px] h-[35px] rounded-full bg-white"
          >
            <span className="text-xl text-primary">
              <FaRegHeart className=" w-5 h-5" />
            </span>
            {wishlist_count !== 0 && (
              <div className="w-[20px] h-[20px] absolute bg-red-500 rounded-full text-white flex justify-center items-center -top-[3px] -right-[5px]">
                {wishlist_count}
              </div>
            )}
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Footer
